import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          Terms and Conditions
        </h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Agreement to Terms</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#555' }}>
              By accessing and using HeyGerman's services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please do not 
              use this service.
            </p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Service Description</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🎓 Educational Services</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  HeyGerman provides digital German language learning services including online courses, 
                  consultation sessions, educational materials, and learning resources.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>💻 Digital Platform</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  All services are provided through our digital platform. Users access content online 
                  through their registered accounts.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>User Responsibilities</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  Provide accurate and complete information during registration
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Maintain the security and confidentiality of your account credentials
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Use the service only for lawful educational purposes
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Not share, distribute, or resell any course materials or content
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Respect intellectual property rights of all educational content
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Payment Terms</h2>
            <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
              <h3 style={{ color: '#856404', marginBottom: '15px' }}>Payment and Billing</h3>
              <ul style={{ color: '#856404', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>All payments must be made in advance before service delivery</li>
                <li style={{ marginBottom: '8px' }}>Prices are subject to change without prior notice</li>
                <li style={{ marginBottom: '8px' }}>All fees are non-refundable as per our refund policy</li>
                <li style={{ marginBottom: '8px' }}>Failed payments may result in service suspension</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Intellectual Property</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '15px' }}>
                All content, materials, courses, and educational resources provided by HeyGerman are 
                protected by intellectual property laws and remain the exclusive property of HeyGerman.
              </p>
              <h3 style={{ color: '#333', marginBottom: '10px' }}>Prohibited Activities:</h3>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Copying, reproducing, or distributing course materials</li>
                <li style={{ marginBottom: '8px' }}>Recording or capturing any video or audio content</li>
                <li style={{ marginBottom: '8px' }}>Reverse engineering or attempting to extract source code</li>
                <li style={{ marginBottom: '8px' }}>Creating derivative works from our content</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Limitation of Liability</h2>
            <div style={{ padding: '20px', backgroundColor: '#e8f4fd', borderRadius: '8px', border: '1px solid #bee5eb' }}>
              <p style={{ color: '#0c5460', margin: 0, lineHeight: '1.6' }}>
                HeyGerman shall not be liable for any indirect, incidental, special, consequential, or 
                punitive damages, including without limitation, loss of profits, data, use, goodwill, 
                or other intangible losses, resulting from your use of the service.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Service Availability</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                We strive to maintain 99% uptime but cannot guarantee uninterrupted service availability. 
                Scheduled maintenance, technical issues, or force majeure events may temporarily affect 
                service access. We reserve the right to modify, suspend, or discontinue any part of our 
                service at any time.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Governing Law</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                These terms and conditions are governed by and construed in accordance with the laws of 
                India. Any disputes arising under these terms shall be subject to the exclusive jurisdiction 
                of the courts in Hyderabad, Telangana.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Contact Information</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', marginBottom: '15px', lineHeight: '1.6' }}>
                For questions regarding these Terms and Conditions, please contact us:
              </p>
              <div style={{ display: 'grid', gap: '10px' }}>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Email:</strong> pawankumar@babycode.org
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Phone:</strong> +919030870876
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Address:</strong> 91springboard, F948+W7, Kondapur, Laxmi Cyber City, 
                  Whitefields, HITEC City, Hyderabad, Telangana 500084
                </p>
              </div>
            </div>
          </div>

          <div style={{ padding: '20px', backgroundColor: '#667eea', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ color: 'white', margin: 0, fontSize: '1rem', lineHeight: '1.5' }}>
              <strong>Last Updated:</strong> September 25, 2025<br />
              By using our services, you acknowledge that you have read and understood these terms.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;